import axios from 'axios'

export default () => axios.create({
  baseURL: process.env.VUE_APP_API_URL ? `${process.env.VUE_APP_API_URL}/api` : `${window.location.protocol}//api.${window.location.host}/api`,
  // A request must never leave an action looking frozen forever. Online game
  // commands use the reconnecting WebSocket queue; HTTP is mostly bootstrap
  // and background synchronisation, where a bounded failure is preferable.
  timeout: 8000,
  params: {
    locale: localStorage.getItem('lang') || 'ru'
  }
})
